import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQuery } from '@/shared/api/auth';
import { applyUserPreferences } from '@/shared/lib/preferences';

/** Every route below requires a session; unauthenticated visitors go to /login and come back afterwards. */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } });
    applyUserPreferences(me.user.settings);
    return { me };
  },
  component: Outlet,
});
